import { Icon } from '@openedx/paragon';
import { InfoOutline as InfoOutlineIcon } from '@openedx/paragon/icons';
import { useIntl } from '@edx/frontend-platform/i18n';

import SidebarSocial from './sidebar-social/SidebarSocial';
import SidebarDetails from './sidebar-details/SidebarDetails';
import type { CourseAboutData } from '../types';
import messages from '../messages';

const CourseSidebar = ({ courseAboutData }: { courseAboutData: CourseAboutData }) => {
  const intl = useIntl();

  return (
    <aside className="course-about-sidebar">
      <div className="course-about-sidebar__inner">
        <div className="course-about-sidebar__header">
          <h2>{intl.formatMessage(messages.courseOverview)}</h2>
          <span className="course-about-sidebar__header-icon" aria-hidden="true">
            <Icon src={InfoOutlineIcon} />
          </span>
        </div>
        <SidebarDetails courseAboutData={courseAboutData} />
        <SidebarSocial courseAboutData={courseAboutData} />
      </div>
    </aside>
  );
};

export default CourseSidebar;
